"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _momentRange = require("moment-range");
var _constants = require("./constants");
// Extend moment to support range
var momentExtended = (0, _momentRange.extendMoment)(_momentTimezone.default);
// Guess timezone of browser
var _guessTimezone = function guessTimezone() {
  return _momentTimezone.default.tz.guess(_constants.Constant.IgnoreCachedTimezone);
};

/**
 * Date Util
 * @type {Object}
 */
var DateUtil = {
  /**
  * Format the date
  * @param  {Date|timestamp|moment} date
  * @param  {String} format The expected format
  * @return {String} The date with expected format
  */
  format: function format(date, _format) {
    return (0, _momentTimezone.default)(date).format(_format);
  },
  /**
   * Get date in timezone
   * @param  {Date} date
   * @param  {String} timezone
   * @return {Date} Date in timezone
   */
  getDateInTimezone: function getDateInTimezone(date) {
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _guessTimezone();
    return (0, _momentTimezone.default)(date).tz(timezone);
  },
  /**
   * Guess timezone of browser
   * @return {String} The browser's timezone
   */
  guessTimezone: function guessTimezone() {
    return _guessTimezone();
  },
  /**
   * Check if {range1} is equal {range2} or not
   */
  isRangeSame: function isRangeSame(range1, range2) {
    var newRange1 = momentExtended.range(range1);
    var newRange2 = momentExtended.range(range2);
    return newRange1.isSame(newRange2);
  },
  now: function now() {
    return (0, _momentTimezone.default)();
  },
  /**
   * Get date in UTC.
   * @param {Date} date
   * @return {Date} Date in UTC mode
   */
  utc: function utc(date) {
    return _momentTimezone.default.utc(date);
  },
  /**
  * Format DOB in MM/DD/YYYY format
  * @param   {String}  dob  DOB
  * @return  {String}       Formated DOB. Return null if the DOB is invalid.
  */
  formatDOB: function formatDOB(dob) {
    var formatedDOB = null;
    var isValidDate = _constants.Constant.DateTimePattern.DOB.test(dob);
    if (isValidDate) {
      formatedDOB = dob.replace(/-/g, '/');
      var formatedDOBsplits = formatedDOB.split('/');
      var month = formatedDOBsplits[0];
      var day = formatedDOBsplits[1];
      var year = formatedDOBsplits[2];
      year = year.length === 2 ? "19".concat(year) : year;
      formatedDOB = "".concat(month, "/").concat(day, "/").concat(year);
      formatedDOB = (0, _momentTimezone.default)(formatedDOB).format(_constants.Constant.DateTimeFormat.shortDate);
      formatedDOB = formatedDOB !== 'Invalid date' ? formatedDOB : null;
    }
    return formatedDOB;
  }
};
// Export date util.
var _default = DateUtil;
exports.default = _default;